import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37f2fee8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup-alert-contain" }
const _hoisted_2 = { class: "popup-alert-contain-inner" }
const _hoisted_3 = { class: "alert-box" }
const _hoisted_4 = { class: "alert-content" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "alert-description" }, [
  /*#__PURE__*/_createTextVNode(" เสียใจด้วย ไพ่ Golden Card ใบสุดท้าย"),
  /*#__PURE__*/_createElementVNode("i", { class: "new-line" }),
  /*#__PURE__*/_createTextVNode(" ถูกลงทะเบียนโดยผู้เล่นท่านอื่นแล้ว"),
  /*#__PURE__*/_createElementVNode("i", { class: "new-line" }),
  /*#__PURE__*/_createTextVNode(" วันนี้ดวงยังไม่เป็นใจ พรุ่งนี้มาเปิดไพ่ใหม่นะ ")
], -1))
const _hoisted_7 = { class: "alert-button-inner" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "button button-leave",
  type: "button"
}, " ออกจากหน้านี้ ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "button button-backward",
  type: "button"
}, "ย้อนกลับ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            class: "alert-icon",
            src: `${require('@/assets/images/home/icon-info.png')}`,
            alt: ""
          }, null, 8, _hoisted_5),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/play" }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}